import React, { useState, useMemo } from 'react';
import TextInput from '../TextInput/TextInput';
import type { Props as TextInputProps } from '../TextInput/TextInput';
import BaseInputIcon from '../BaseInput/BaseInputIcon';

export type EmailInputProps = TextInputProps;
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const EmailInput: React.FC<EmailInputProps> = (props) => {
  const {
    value = '',
    label = 'Email address',
    placeholder = 'user@domain.com',
    onChange,
    ...commonProps
  } = props;

  const [valid, setValid] = useState<boolean>(EMAIL_PATTERN.test(value));

  const validInputIcon = useMemo(
    () =>
      valid ? (
        <BaseInputIcon
          aria-label="Valid"
          icon="checkmarkCircleInverted"
          color={{
            type: 'theme',
            colorLegacy: 'Green/50',
            colorNext: 'success/default',
          }}
        />
      ) : null,
    [valid]
  );

  const validateEmailInput = (val: string): void => {
    if (EMAIL_PATTERN.test(val)) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const onChangeFn = (newInputValue: string) => {
    validateEmailInput(newInputValue);
    if (onChange) onChange(newInputValue);
  };

  return (
    <TextInput
      {...commonProps}
      label={label}
      value={value}
      onChange={onChangeFn}
      placeholder={placeholder}
      adornmentRight={validInputIcon}
      autoComplete="email"
    />
  );
};

export default EmailInput;
